import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-about-me',
    templateUrl: './about-me.component.html',
    styleUrls: ['./about-me.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class AboutMeComponent implements OnInit {

    constructor(
        private titleService: Title
    ) {
    }

    ngOnInit() {
        this.titleService.setTitle('Alexander Koenig - Über mich');
    }

}
